// Section handlers
const scriptSectionType = {
  SECTION_BANNER: 'section-banner',
  SECTION_BANNER_HSIA: 'section-banner-hsia',
  SECTION_BANNER_KYNORELLE: 'section-banner-kynorelle',
  SECTION_GRID_ITEM_KYNORELLE: 'section-grid-item-kynorelle',
  SECTION_GRID_ITEM_KYNORELLE_02: 'section-grid-item-kynorelle-02',
  SECTION_GRID_ITEM_KYNORELLE_04: 'section-grid-item-kynorelle-04',
  SECTION_MARKQUEUE_KYNORELLE: 'section-markqueue-kynorelle',
  SECTION_MARQUEE_KYRORO: 'section-marquee-kyroro',
  SECTION_MARQUEE_BOXER_ITEM: 'section-marquee-boxer-item',
  SECTION_CARD_FAQ_KYNORELLE: 'section-card-faq-kynorelle',
  SECTION_SLIDER_REVIEW_KYNORELLE: 'section-slider-review-kynorelle',
  SECTION_CARD_VIDEO_SLIDER: 'section-card-video-slider',
  SECTION_PRODUCTS_SLIDER: 'section-products',
  SECTION_SLIDER_ITEM_FYRORO: 'section-slider-item-fyroro',
  SECTION_SLIDER_ITEM_BOXER: 'section-slider-item-boxer',
  SECTION_PRODUCT_WITH_VARIANT: 'section-product-with-variant',
  SECTION_CARD_WITH_TABS_BOXER: 'section-card-with-tabs-boxer',
  SECTION_CARD_MULTI_BOXER: 'section-card-multi-boxer',
  SECTION_CARD_REVIEWS_BOXER: 'section-card-reviews-boxer',
  SECTION_SLIDER_BOXER_PRODUCT: 'section-slider-boxer-product',
  SECTION_CALYRAFIT_MARQUEE_01: 'section-calyrafit-marquee-01',
  SECTION_CALYRAFIT_MARQUEE: 'section-calyrafit-marquee',
  SECTION_CALYRAFIT_BEST_SALLER: 'section-calyrafit-best-saller',
  SECTION_CALYRAFIT_SLIDE: 'section-calyrafit-slide',
  SECTION_CALYRAFIT_COLLECTIONS: 'section-calyrafit-collections',
  SECTION_CALYRAFIT_REVIEW: 'section-calyrafit-review',
};

let swiperLoadPromise = null;

function loadSwiper(callback) {
  if (window.Swiper && typeof window.Swiper === 'function') {
    callback();
    return;
  }

  const existing = document.querySelector('script[data-attribute="script-swiper"]');
  if (existing && existing.dataset.loaded === 'true') {
    callback();
    return;
  }

  if (!swiperLoadPromise) {
    swiperLoadPromise = new Promise((resolve, reject) => {
      const handleLoaded = () => {
        if (existing) {
          existing.dataset.loaded = 'true';
        }
        resolve();
      };

      const handleError = () => {
        reject(new Error('Failed to load swiper script'));
      };

      if (existing) {
        existing.addEventListener('load', handleLoaded, { once: true });
        existing.addEventListener('error', handleError, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.dataset.attribute = 'script-swiper';
      script.onload = () => {
        script.dataset.loaded = 'true';
        resolve();
      };
      script.onerror = handleError;
      document.head.appendChild(script);
    }).finally(() => {
      swiperLoadPromise = null;
    });
  }

  swiperLoadPromise
    .then(() => {
      callback();
    })
    .catch(error => {
      console.error(error);
    });
}

function duplicateMarkqueueRows(uniqueId) {
  const isSection = document.querySelector(`[data-attribute="card-container"][data-id="${uniqueId}"]`);
  if (!isSection) return;
  const elMarkqueue = isSection.querySelector('[data-attribute="block-markqueue"]');
  if (!elMarkqueue) return;
  if (elMarkqueue.getAttribute('data-markqueue-duplicated') === 'true') return;

  elMarkqueue.innerHTML = Array(40)
    .fill(elMarkqueue.innerHTML)
    .join('');
  elMarkqueue.setAttribute('data-markqueue-duplicated', 'true');
}

function duplicateMarqueeBoxerList(uniqueId) {
  const sectionRoot = document.querySelector(`[data-attribute="card-container"][data-id="${uniqueId}"]`);
  if (!sectionRoot) return;
  const blockMarquee = sectionRoot.querySelector('[data-attribute="block-marquee"]');
  if (!blockMarquee || blockMarquee.getAttribute('data-list-duplicated') === 'true') return;

  const listItem = blockMarquee.querySelector('[data-attribute="list-item"]');
  if (!listItem) return;

  const itemEls = listItem.querySelectorAll('[data-attribute="item"]');
  const lengthItem = Array.from(itemEls).length || 10;
  // if (!lengthItem) return;
  if (lengthItem < 10) {
    const xClone = 10 - lengthItem;
    for (let i = 0; i < xClone; i++) {
      const targetItem = itemEls[i % lengthItem];

      if (targetItem) {
        const cloneItem = targetItem.cloneNode(true);
        listItem.appendChild(cloneItem);
      }
    }
  }

  const listItems = Array.from(blockMarquee.children).filter(
    child => child.getAttribute('data-attribute') === 'list-item',
  );
  if (listItems.length < 2) {
    blockMarquee.appendChild(listItem.cloneNode(true));
  }
  blockMarquee.setAttribute('data-list-duplicated', 'true');
}

const helperFunctions = {
  sectionBanner: uniqueId => {
    new window.Swiper(`.mySwiperBannerSlider-${uniqueId}`, {
      slidesPerView: 1,
      spaceBetween: 15,
      pagination: {
        el: `.mySwiperBannerSlider-${uniqueId} .swiper-pagination`,
        clickable: true,
      },
    });
  },
  sectionBannerHsia: uniqueId => {
    const sectionRoot = document.querySelector(`[data-id="${uniqueId}"]`);
    if (!sectionRoot) return;

    const swiperRoot = sectionRoot.querySelector('.swiper');
    if (!swiperRoot) return;

    const paginationEl = sectionRoot.querySelector('.swiper-pagination');

    new window.Swiper(swiperRoot, {
      slidesPerView: 1,
      spaceBetween: 15,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        waitForTransition: true,
      },
      effect: 'fade',
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });
  },
  sectionBannerKynorelle: uniqueId => {
    new window.Swiper(`.mySwiperBannerKynorelle-${uniqueId}`, {
      slidesPerView: 1,
      spaceBetween: 15,
      pagination: {
        el: `.mySwiperBannerKynorelle-${uniqueId} .swiper-pagination`,
        clickable: true,
      },
    });
  },
  sectionGridItemKynorelle: uniqueId => {
    const swiperRootSelector = `[data-id="${uniqueId}"] .swiper`;
    const paginationSelector = `[data-id="${uniqueId}"] .swiper-pagination`;
    if (!document.querySelector(swiperRootSelector)) return;

    new window.Swiper(swiperRootSelector, {
      slidesPerView: 2,
      spaceBetween: 15,
      pagination: {
        el: paginationSelector,
        clickable: true,
      },
      breakpointsBase: 'container',
      breakpoints: {
        768: {
          spaceBetween: 30,
          slidesPerView: 3,
        },
      },
    });
  },
  sectionGridItemKynorelle02: uniqueId => {
    duplicateMarkqueueRows(uniqueId);
  },
  sectionMarkqueueKynorelle: uniqueId => {
    duplicateMarkqueueRows(uniqueId);
  },
  sectionMarqueeKyroro: uniqueId => {
    const isSection = document.querySelector(`[data-attribute="card-container"][data-id="${uniqueId}"]`);
    if (!isSection) return;
    const elMarkqueue = isSection.querySelector('[data-attribute="block-markqueue"]');
    if (!elMarkqueue) return;
    if (elMarkqueue.getAttribute('data-markqueue-duplicated') === 'true') return;

    elMarkqueue.innerHTML = Array(40)
      .fill(elMarkqueue.innerHTML)
      .join('');
    elMarkqueue.setAttribute('data-markqueue-duplicated', 'true');
  },
  sectionMarqueeBoxerItem: uniqueId => {
    duplicateMarqueeBoxerList(uniqueId);
  },
  sectionCalyrafitMarquee01: uniqueId => {
    duplicateMarqueeBoxerList(uniqueId);
  },
  sectionCalyrafitMarquee: uniqueId => {
    duplicateMarqueeBoxerList(uniqueId);
  },
  sectionGridItemKynorelle04: uniqueId => {
    const swiperRootSelector = `[data-id="${uniqueId}"] .swiper`;
    const paginationSelector = `[data-id="${uniqueId}"] .swiper-pagination`;
    if (!document.querySelector(swiperRootSelector)) return;

    new window.Swiper(swiperRootSelector, {
      slidesPerView: 1,
      spaceBetween: 30,
      pagination: {
        el: paginationSelector,
        clickable: true,
      },
      breakpointsBase: 'container',
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });
  },
  sectionCardFaqKynorelle: uniqueId => {
    const container = document.querySelector(`#card-container-${uniqueId}`);
    if (!container) return;

    const faqQuestions = container.querySelectorAll('[data-attribute="accordion-title"]');
    faqQuestions.forEach(question => {
      question.addEventListener('click', () => {
        const answer = question.nextElementSibling;
        if (!answer) return;

        const isOpen = answer.classList.contains('open');
        container.querySelectorAll('[data-attribute="accordion-content"]').forEach(ans => {
          ans.classList.remove('open');
          ans.style.maxHeight = null;
        });
        container.querySelectorAll('.accordion-icon').forEach(icon => {
          icon.classList.remove('open');
        });

        if (!isOpen) {
          answer.classList.add('open');
          answer.style.maxHeight = `${answer.scrollHeight}px`;
          question.querySelector('.accordion-icon')?.classList.add('open');
        }
      });
    });
  },
  sectionSliderReviewKynorelle: uniqueId => {
    const container = document.querySelector(`#card-container-${uniqueId}`);
    if (!container) return;

    if (window.Swiper && typeof window.Swiper === 'function') {
      const swiperEl = container.querySelector('.swiper');
      if (!swiperEl) return;

      const bodyReview = container.querySelector('[data-attribute="body-review"]');
      const slidesPerViewDesktop = parseInt(bodyReview?.getAttribute('data-col-per-view') || '4', 10) || 4;

      new window.Swiper(swiperEl, {
        slidesPerView: 2,
        spaceBetween: 10,
        navigation: {
          nextEl: `#card-container-${uniqueId} .swiper-button-next`,
          prevEl: `#card-container-${uniqueId} .swiper-button-prev`,
        },
        breakpointsBase: 'container',
        // loop: true,
        // autoplay: {
        //   delay: 2500,
        //   disableOnInteraction: false,
        // },
        pagination: {
          el: `#card-container-${uniqueId} .swiper-pagination`,
          clickable: true,
        },
        breakpoints: {
          640: {
            slidesPerView: 3,
            spaceBetween: '20px',
          },
          1024: {
            spaceBetween: '40px',
            slidesPerView: slidesPerViewDesktop,
          },
        },
      });
    }
  },
  sectionCardVideoSlider: uniqueId => {
    const container = document.querySelector(`#card-container-${uniqueId}`);
    const videos = container.querySelectorAll('.wrap-item video');

    videos.forEach(video => {
      const wrap = video.closest('.wrap-item');
      const playBtn = wrap.querySelector('.playvideo');
      const volumeWrap = wrap.querySelector('.volume');
      const volumeIcon = volumeWrap.querySelector('.volume-icon');
      const muteIcon = volumeWrap.querySelector('.mute-icon');
      const loading = wrap.querySelector('.video-loading');

      video.addEventListener('waiting', () => {
        loading.style.display = 'flex';
      });

      video.addEventListener('canplay', () => {
        loading.style.display = 'none';
      });

      video.addEventListener('playing', () => {
        loading.style.display = 'none';
      });

      video.addEventListener('click', () => {
        if (video.paused) {
          video.play();
          playBtn.style.display = 'none';
          loading.style.display = 'none';
        } else {
          video.pause();
          playBtn.style.display = 'flex';
        }
      });

      video.addEventListener('ended', () => {
        playBtn.style.display = 'flex';
      });

      volumeWrap.addEventListener('click', () => {
        if (video.muted) {
          video.muted = false;
          volumeIcon.style.display = 'flex';
          muteIcon.style.display = 'none';
        } else {
          video.muted = true;
          volumeIcon.style.display = 'none';
          muteIcon.style.display = 'flex';
        }
      });
    });
    new window.Swiper(`.swiper-video-${uniqueId}`, {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: true,
      navigation: {
        nextEl: `.next-${uniqueId}`,
        prevEl: `.prev-${uniqueId}`,
      },
      breakpoints: {
        640: { slidesPerView: 2 },
        800: { slidesPerView: 3 },
        1200: { slidesPerView: 5 },
      },
    });
  },
  sectionProductsSlider: uniqueId => {
    new window.Swiper(`.swiper-product-${uniqueId}`, {
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: `.next-${uniqueId}`,
        prevEl: `.prev-${uniqueId}`,
      },
      breakpointsBase: 'container',
      breakpoints: {
        768: {
          slidesPerView: 2.5,
        },
        1024: {
          slidesPerView: 3,
        },
      },
    });
  },
  sectionProductWithVariant: uniqueId => {
    const sectionContainer = document.querySelector(`[data-id="${uniqueId}"]`);
    if (!sectionContainer) return;

    const listItem = sectionContainer.querySelector('[data-attribute="list-item"]');
    const colPerView =
      Number(listItem?.getAttribute('data-col-perview')) > 0 ? Number(listItem.getAttribute('data-col-perview')) : 4;
    const spaceBetween =
      Number(listItem?.getAttribute('data-space-between')) >= 0
        ? Number(listItem.getAttribute('data-space-between'))
        : 25;

    const swiperRoot = sectionContainer.querySelector('.swiper');

    if (swiperRoot) {
      new window.Swiper(swiperRoot, {
        slidesPerView: 2,
        spaceBetween: 15,
        navigation: {
          nextEl: sectionContainer.querySelector('.swiper-button-next'),
          prevEl: sectionContainer.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: sectionContainer.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpointsBase: 'container',
        breakpoints: {
          640: { slidesPerView: 2, spaceBetween },
          1024: { slidesPerView: colPerView, spaceBetween },
        },
      });
    }

    sectionContainer.querySelectorAll('[data-attribute="product-item"]').forEach(productEl => {
      const wrapImages = productEl.querySelector('[data-attribute="list-img-color-variant"]');
      const listSwatch = productEl.querySelector('[data-attribute="list-color-variant"]');
      const blockImagesItemProduct = productEl.querySelector('.block-imgs-product');
      if (!wrapImages || !listSwatch || !blockImagesItemProduct) return;

      listSwatch.querySelectorAll('[data-attribute="color-variant"]').forEach(swatch => {
        swatch.addEventListener('mouseenter', event => {
          event.preventDefault();
          const key = swatch.getAttribute('data-color-variant');
          if (!key) return;

          listSwatch.querySelectorAll('[data-attribute="color-variant"]').forEach(el => {
            el.classList.toggle('active', el === swatch);
            el.setAttribute('data-active', el === swatch ? 'true' : 'false');
          });

          wrapImages.querySelectorAll('[data-attribute="color-variant"]').forEach(group => {
            const matched = group.getAttribute('data-color-variant') === key;
            group.classList.toggle('active', matched);
            group.querySelectorAll('.wrap-img-color').forEach(img => {
              img.classList.remove('active');
            });
            group.setAttribute('data-active', matched ? 'true' : 'false');

            if (matched) {
              const firstChild = group.querySelector('.wrap-img-color');
              if (firstChild) {
                firstChild.classList.add('active');
              }
            }
          });
        });
      });

      const navigateSwatchItem = () => {
        const currentActive = wrapImages.querySelector('.wrap-img-color.active');
        const parentGroup = currentActive.closest('[data-attribute="color-variant"]');
        parentGroup.classList.remove('active');
        parentGroup.setAttribute('data-active', 'false');
        const indexCurrentActive = Array.from(wrapImages.querySelectorAll('.wrap-img-color')).indexOf(currentActive);
        const handlePrevSwatch = () => {
          wrapImages.querySelectorAll('.wrap-img-color').forEach((platImgColor, index, arrayWrapImgColor) => {
            const lengthArrayWrapImgColor = arrayWrapImgColor.length;
            platImgColor.classList.remove('active');
            const parentGroupPlatImgColor = platImgColor.closest('[data-attribute="color-variant"]');
            if (indexCurrentActive === 0) {
              if (index === lengthArrayWrapImgColor - 1) {
                platImgColor.classList.add('active');
                parentGroupPlatImgColor.classList.add('active');
                parentGroupPlatImgColor.setAttribute('data-active', 'true');
              }
            } else {
              if (index === indexCurrentActive - 1) {
                platImgColor.classList.add('active');
                parentGroupPlatImgColor.classList.add('active');
                parentGroupPlatImgColor.setAttribute('data-active', 'true');
              }
            }
          });
        };
        const handleNextSwatch = () => {
          wrapImages.querySelectorAll('.wrap-img-color').forEach((platImgColor, index, arrayWrapImgColor) => {
            const lengthArrayWrapImgColor = arrayWrapImgColor.length;
            platImgColor.classList.remove('active');
            const parentGroupPlatImgColor = platImgColor.closest('[data-attribute="color-variant"]');
            if (indexCurrentActive === lengthArrayWrapImgColor - 1) {
              if (index === 0) {
                platImgColor.classList.add('active');
                parentGroupPlatImgColor.classList.add('active');
                parentGroupPlatImgColor.setAttribute('data-active', 'true');
              }
            } else {
              if (index === indexCurrentActive + 1) {
                platImgColor.classList.add('active');
                parentGroupPlatImgColor.classList.add('active');
                parentGroupPlatImgColor.setAttribute('data-active', 'true');
              }
            }
          });
        };
        return {
          handlePrevSwatch,
          handleNextSwatch,
        };
      };
      const prevSwatch = productEl.querySelector('.prev-product');
      const nextSwatch = productEl.querySelector('.next-product');
      if (prevSwatch && nextSwatch) {
        prevSwatch.addEventListener('click', () => {
          navigateSwatchItem().handlePrevSwatch();
        });
        nextSwatch.addEventListener('click', () => {
          navigateSwatchItem().handleNextSwatch();
        });
      }

      blockImagesItemProduct.addEventListener('mouseenter', () => {
        navigateSwatchItem().handleNextSwatch();
      });
      blockImagesItemProduct.addEventListener('mouseleave', () => {
        navigateSwatchItem().handlePrevSwatch();
      });
    });
  },
  sectionSliderItemFyroro: uniqueId => {
    const sectionContainer = document.querySelector(`[data-id="${uniqueId}"]`);
    if (!sectionContainer) return;

    const swiperRoot = sectionContainer.querySelector('.swiper');
    if (!swiperRoot) return;

    const slidesPerView =
      Number(
        sectionContainer.querySelector('[data-attribute="slider-product"]')?.getAttribute('data-slide-per-view'),
      ) || 3;

    new window.Swiper(swiperRoot, {
      slidesPerView: 1.5,
      spaceBetween: 15,
      navigation: {
        nextEl: sectionContainer.querySelector('.swiper-button-next'),
        prevEl: sectionContainer.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: sectionContainer.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpointsBase: 'container',
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        1024: {
          slidesPerView: slidesPerView,
          spaceBetween: 40,
        },
      },
    });
  },
  sectionCardWithTabsBoxer: uniqueId => {
    const sectionContainer = document.querySelector(`[data-id="${uniqueId}"]`);
    if (!sectionContainer) return;

    const tabNavEls = sectionContainer.querySelectorAll('[data-attribute="tab-nav-item"]');
    const tabContentEls = sectionContainer.querySelectorAll('[data-attribute="tab-content"]');
    if (!tabNavEls.length || !tabContentEls.length) return;

    const activate = key => {
      tabNavEls.forEach(nav => {
        nav.classList.toggle('active', nav.getAttribute('data-tab') === key);
      });
      tabContentEls.forEach(content => {
        content.classList.toggle('active', content.getAttribute('data-tab') === key);
      });
    };

    tabNavEls.forEach(nav => {
      nav.addEventListener('click', () => {
        const key = nav.getAttribute('data-tab');
        if (key) activate(key);
      });
    });

    const defaultActive = sectionContainer.querySelector('[data-attribute="tab-nav-item"].active') || tabNavEls[0];
    const defaultKey = defaultActive ? defaultActive.getAttribute('data-tab') : null;
    if (defaultKey) activate(defaultKey);
  },
  sectionCardMultiBoxer: uniqueId => {
    const container = document.querySelector(`#card-container-${uniqueId}`);
    if (!container) return;

    const swiperRoot = container.querySelector('.swiper');
    if (swiperRoot && window.Swiper && typeof window.Swiper === 'function') {
      new window.Swiper(swiperRoot, {
        slidesPerView: 1,
        spaceBetween: 15,
        speed: 600,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
      });
    }

    const accordionTitles = container.querySelectorAll('[data-attribute="accordion-title"]');
    accordionTitles.forEach(question => {
      question.addEventListener('click', () => {
        const answer = question.nextElementSibling;
        if (!answer) return;

        const isOpen = answer.classList.contains('open');
        container.querySelectorAll('[data-attribute="accordion-content"]').forEach(ans => {
          ans.classList.remove('open');
          ans.style.maxHeight = null;
        });
        container.querySelectorAll('.accordion-icon').forEach(icon => {
          icon.classList.remove('open');
        });

        if (!isOpen) {
          answer.classList.add('open');
          answer.style.maxHeight = `${answer.scrollHeight}px`;
          question.querySelector('.accordion-icon')?.classList.add('open');
        }
      });
    });
  },
  sectionCardReviewsBoxer: uniqueId => {
    const container = document.querySelector(`#card-container-${uniqueId}`);
    if (!container) return;

    const swiperRoot = container.querySelector('.swiper');
    if (!swiperRoot) return;

    const listEl = container.querySelector('[data-attribute="list-item"]');
    const slidesPerView = Number(listEl?.getAttribute('data-col-per-view')) || 4;
    const spaceBetween = Number(listEl?.getAttribute('data-space-between')) || 16;

    if (window.Swiper && typeof window.Swiper === 'function') {
      new window.Swiper(swiperRoot, {
        slidesPerView: 2,
        spaceBetween: 15,
        loop: true,
        speed: 600,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpointsBase: 'container',
        breakpoints: {
          768: {
            slidesPerView: Math.min(2, slidesPerView),
            spaceBetween,
          },
          1024: {
            slidesPerView,
            spaceBetween,
          },
        },
      });
    }
  },
  sectionCalyrafitReview: uniqueId => {
    const container = document.querySelector(`#card-container-${uniqueId}`);
    if (!container) return;

    const listEl = container.querySelector('[data-attribute="list-review"]');
    if (!listEl) return;

    const slidesPerView = Number(listEl.getAttribute('data-col-per-view')) || 3;
    const spaceBetween = Number(listEl.getAttribute('data-space-between')) || 24;

    if (window.Swiper && typeof window.Swiper === 'function') {
      new window.Swiper(listEl, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        // speed: 600,
        // autoplay: {
        //   delay: 3000,
        //   disableOnInteraction: false,
        //   pauseOnMouseEnter: true,
        // },
        breakpointsBase: 'container',
        breakpoints: {
          768: {
            slidesPerView: Math.min(2, slidesPerView),
            spaceBetween,
          },
          1024: {
            slidesPerView,
            spaceBetween,
          },
        },
      });
    }
  },
  sectionSliderBoxerProduct: uniqueId => {
    const container = document.querySelector(`#card-container-${uniqueId}`);
    if (!container) return;

    const swiperRoot = container.querySelector('.swiper');
    if (!swiperRoot) return;

    const listEl = container.querySelector('[data-attribute="list-item"]');
    const slidesPerView = Number(listEl?.getAttribute('data-col-per-view')) || 3;
    const spaceBetween = Number(listEl?.getAttribute('data-space-between')) || 16;

    if (window.Swiper && typeof window.Swiper === 'function') {
      new window.Swiper(swiperRoot, {
        slidesPerView: 1.5,
        spaceBetween: 12,
        loop: true,
        speed: 600,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        navigation: {
          nextEl: container.querySelector('.swiper-button-next'),
          prevEl: container.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpointsBase: 'container',
        breakpoints: {
          768: {
            slidesPerView: Math.min(2, slidesPerView),
            spaceBetween,
          },
          1024: {
            slidesPerView,
            spaceBetween,
          },
        },
      });
    }
  },
  sectionSliderItemBoxer: uniqueId => {
    const sectionContainer = document.querySelector(`[data-id="${uniqueId}"]`);
    if (!sectionContainer) return;

    const swiperRoot = sectionContainer.querySelector('.swiper');
    if (!swiperRoot) return;

    const wrapItems = sectionContainer.querySelector('[data-attribute="wrap-items"]');
    const slidesPerView = Number(wrapItems?.getAttribute('data-col-per-view')) || 3;
    const spaceBetweenAttr = wrapItems?.getAttribute('data-space-between') || '30px';
    const spaceBetween = parseInt(spaceBetweenAttr, 10) || 30;

    new window.Swiper(swiperRoot, {
      slidesPerView: 1.3,
      spaceBetween: 15,
      speed: 600,
      loop: true,
      pagination: {
        el: sectionContainer.querySelector('.swiper-pagination'),
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      breakpointsBase: 'container',
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween,
        },
        1024: {
          slidesPerView,
          spaceBetween,
        },
      },
    });
  },
  sectionCalyrafitBestSaller: uniqueId => {
    const sectionContainer = document.querySelector(`[data-attribute="card-container"][data-id="${uniqueId}"]`);
    if (!sectionContainer) return;

    const swiperRoot = sectionContainer.querySelector('[data-attribute="grid-products-mobile"] .swiper');
    if (!swiperRoot) return;

    if (window.Swiper && typeof window.Swiper === 'function') {
      new window.Swiper(swiperRoot, {
        slidesPerView: 1.5,
        spaceBetween: 12,
        breakpointsBase: 'container',
        breakpoints: {
          640: {
            slidesPerView: 2,
          },
        },
      });
    }
  },
  sectionCalyrafitSlide: uniqueId => {
    const sectionContainer = document.querySelector(`[data-attribute="card-container"][data-id="${uniqueId}"]`);
    if (!sectionContainer) return;

    const swiperRoot = sectionContainer.querySelector('.swiper');
    if (!swiperRoot) return;

    if (window.Swiper && typeof window.Swiper === 'function') {
      new window.Swiper(swiperRoot, {
        slidesPerView: 1.6,
        spaceBetween: 0,
        navigation: {
          nextEl: sectionContainer.querySelector('.swiper-button-next'),
          prevEl: sectionContainer.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: sectionContainer.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpointsBase: 'container',
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
          1200: {
            slidesPerView: 4,
          },
        },
      });
    }
  },
  sectionCalyrafitCollections: uniqueId => {
    const sectionContainer = document.querySelector(`[data-attribute="card-container"][data-id="${uniqueId}"]`);
    if (!sectionContainer) return;

    const swiperRoot = sectionContainer.querySelector('.swiper');
    if (!swiperRoot) return;

    if (window.Swiper && typeof window.Swiper === 'function') {
      new window.Swiper(swiperRoot, {
        slidesPerView: 2,
        spaceBetween: 16,
        breakpointsBase: 'container',
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
      });
    }
  },
};

const insertAnchorItem = (section, elMenu) => {
  if (!elMenu || !section) return;
  const nameAnchor = section.getAttribute('data-title');
  if (!nameAnchor) return;
  const enableAnchor = section.getAttribute('data-enable-anchor');
  if (enableAnchor === 'false' || !enableAnchor) return;

  const innerId = section.querySelector('[data-id]')?.getAttribute('data-id') || '';
  const stableKey =
    innerId ||
    nameAnchor
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');

  const existed = elMenu.querySelector(`[data-anchor-for="${stableKey}"]`);
  if (existed) return;

  const elMenuItem = elMenu.firstElementChild;
  const className = elMenuItem?.className || '';

  const newElMenuItem = document.createElement('div');
  newElMenuItem.className = className;
  newElMenuItem.textContent = nameAnchor;
  newElMenuItem.setAttribute('data-anchor-for', stableKey);
  elMenu.appendChild(newElMenuItem);

  newElMenuItem.addEventListener('click', () => {
    try {
      let foundSection = null;
      if (innerId) {
        const inner = document.querySelector(`[data-id="${innerId}"]`);
        foundSection = inner ? inner.closest('section[data-type]') : null;
      }
      if (!foundSection) {
        const candidates = Array.from(document.querySelectorAll('section[data-type]')).filter(
          s => s.getAttribute('data-title') === nameAnchor,
        );
        foundSection = candidates.length ? candidates[0] : null;
      }

      if (foundSection) {
        foundSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    } catch (_e) {
      console.log('Error in insertAnchorItem', _e);
    }
  });
};

export function sectionHomepage(options) {
  const init = () => {
    const sectionHandlers = {
      [scriptSectionType.SECTION_BANNER]: helperFunctions.sectionBanner,
      [scriptSectionType.SECTION_BANNER_HSIA]: helperFunctions.sectionBannerHsia,
      [scriptSectionType.SECTION_BANNER_KYNORELLE]: helperFunctions.sectionBannerKynorelle,
      [scriptSectionType.SECTION_GRID_ITEM_KYNORELLE]: helperFunctions.sectionGridItemKynorelle,
      [scriptSectionType.SECTION_GRID_ITEM_KYNORELLE_02]: helperFunctions.sectionGridItemKynorelle02,
      [scriptSectionType.SECTION_GRID_ITEM_KYNORELLE_04]: helperFunctions.sectionGridItemKynorelle04,
      [scriptSectionType.SECTION_MARKQUEUE_KYNORELLE]: helperFunctions.sectionMarkqueueKynorelle,
      [scriptSectionType.SECTION_MARQUEE_KYRORO]: helperFunctions.sectionMarqueeKyroro,
      [scriptSectionType.SECTION_MARQUEE_BOXER_ITEM]: helperFunctions.sectionMarqueeBoxerItem,
      [scriptSectionType.SECTION_CARD_FAQ_KYNORELLE]: helperFunctions.sectionCardFaqKynorelle,
      [scriptSectionType.SECTION_SLIDER_REVIEW_KYNORELLE]: helperFunctions.sectionSliderReviewKynorelle,
      [scriptSectionType.SECTION_CARD_VIDEO_SLIDER]: helperFunctions.sectionCardVideoSlider,
      [scriptSectionType.SECTION_PRODUCTS_SLIDER]: helperFunctions.sectionProductsSlider,
      [scriptSectionType.SECTION_SLIDER_ITEM_FYRORO]: helperFunctions.sectionSliderItemFyroro,
      [scriptSectionType.SECTION_SLIDER_ITEM_BOXER]: helperFunctions.sectionSliderItemBoxer,
      [scriptSectionType.SECTION_PRODUCT_WITH_VARIANT]: helperFunctions.sectionProductWithVariant,
      [scriptSectionType.SECTION_CARD_WITH_TABS_BOXER]: helperFunctions.sectionCardWithTabsBoxer,
      [scriptSectionType.SECTION_CARD_MULTI_BOXER]: helperFunctions.sectionCardMultiBoxer,
      [scriptSectionType.SECTION_CARD_REVIEWS_BOXER]: helperFunctions.sectionCardReviewsBoxer,
      [scriptSectionType.SECTION_SLIDER_BOXER_PRODUCT]: helperFunctions.sectionSliderBoxerProduct,
      [scriptSectionType.SECTION_CALYRAFIT_MARQUEE_01]: helperFunctions.sectionCalyrafitMarquee01,
      [scriptSectionType.SECTION_CALYRAFIT_MARQUEE]: helperFunctions.sectionCalyrafitMarquee,
      [scriptSectionType.SECTION_CALYRAFIT_BEST_SALLER]: helperFunctions.sectionCalyrafitBestSaller,
      [scriptSectionType.SECTION_CALYRAFIT_SLIDE]: helperFunctions.sectionCalyrafitSlide,
      [scriptSectionType.SECTION_CALYRAFIT_COLLECTIONS]: helperFunctions.sectionCalyrafitCollections,
      [scriptSectionType.SECTION_CALYRAFIT_REVIEW]: helperFunctions.sectionCalyrafitReview,
    };

    const sections = document.querySelectorAll('[data-type]');

    const attributeMenu = options?.attributeMenu || '.menu-list-desktop';

    const elMenu = document.querySelectorAll(attributeMenu);

    sections.forEach(section => {
      if (!section) return;

      //handleSection
      const key = section.getAttribute('data-type');
      const executed = section.getAttribute('data-executed');
      const uniqueId = section.querySelector('[data-id]')?.getAttribute('data-id');
      if (executed || !key /*|| !uniqueId*/) return;

      const handler = sectionHandlers[key];
      if (typeof handler === 'function') {
        try {
          if (uniqueId) {
            handler(uniqueId);
            section.setAttribute('data-executed', 'true');
          }
        } catch (err) {
          console.error(`Error executing section [${key}] with id [${uniqueId}]`, err);
        }
      }
      if (elMenu && elMenu.length) {
        elMenu.forEach(el => {
          insertAnchorItem(section, el);
        });
      }
    });
  };

  try {
    if (options && options.force && typeof document !== 'undefined') {
      const executedSections = document.querySelectorAll('section[data-type][data-executed="true"]');
      executedSections.forEach(section => {
        try {
          section.removeAttribute('data-executed');
        } catch (_e) {
          console.error('Error removing attribute data-executed', _e);
        }
      });
    }
  } catch (_e) {
    console.error('Error in try block', _e);
  }

  loadSwiper(init);
}
